var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app"},[_c('div',{staticClass:"wrapper",staticStyle:{"display":"flex","flex-direction":"row"},attrs:{"id":"app"}},[_c('menu-drawer'),_vm._v(" "),_c('main',{staticClass:"main",staticStyle:{"padding":"0"}},[_c('the-header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',[_c('router-view')],1)])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188f88dd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Home.vue
// module id = 448
// module chunks = 1